import React from 'react';

function Step5({ formData, errors, onChange, bancos }) {
  return (
    <div className="step-panel">

      <div className="field-group">
      <label htmlFor="banco">Banco para el pago de nómina</label>
      
      <select
        id="banco"
        name="banco" 
        value={formData.banco || ''}
        onChange={onChange}
        className={errors.banco ? 'error-field' : ''}
      >
        <option value="">Seleccione un banco...</option>
        
        {bancos && bancos.map((banco) => (
          <option key={banco.id} value={banco.nombre_banco || banco.nombre}>
            {banco.nombre_banco || banco.nombre} 
          </option>
        ))}
      </select>

       {errors.banco && <span className="field-error">{errors.banco}</span>}
    </div>

      <div className="field-group">
        <label>
          Tipo de Cuenta <span className="required">*</span>
        </label>
        <div className="radio-group">
          <label className="radio-option">
            <input
              type="radio"
              name="tipoCuenta"
              value="Ahorros"
              checked={formData.tipoCuenta === 'Ahorros'}
              onChange={onChange}
            />
            Ahorros
          </label>

          <label className="radio-option">
            <input
              type="radio"
              name="tipoCuenta"
              value="Corriente"
              checked={formData.tipoCuenta === 'Corriente'}
              onChange={onChange}
            />
            Corriente
          </label>
        </div>
        {errors.tipoCuenta && <span className="field-error">{errors.tipoCuenta}</span>}
      </div>
      
      <div className="field-group">
        <label htmlFor="numeroCuenta">
          Número de Cuenta <span className="required">*</span>
        </label>
        <input
          id="numeroCuenta"
          name="numeroCuenta"
          type="number"
          value={formData.numeroCuenta}
          onChange={onChange}
          placeholder="Ingrese el número de su cuenta"
        />
        {errors.numeroCuenta && <span className="field-error">{errors.numeroCuenta}</span>}
      </div>

    </div>
  );
}

export default Step5;
